import { Box, Typography } from '@mui/material';
import React from 'react';

const Content = () => {
    const operatingHours = [
        { day: 'יום ראשון', hours: '10:00 - 17:00' },
        { day: 'יום שני', hours: '10:00 - 17:00' },
        { day: 'יום שלישי', hours: '10:00 - 17:00' },
        { day: 'יום רביעי', hours: '10:00 - 17:00' },
        { day: 'יום חמישי', hours: '10:00 - 17:00' },
    ];

    return (
        <Box>
            <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g id="Component 2">
                        <path 
                            id="Icon" 
                            d="M8.38028 8.85323C9.07627 10.3028 10.0251 11.6615 11.2266 12.8631C12.4282 14.0646 13.7869 15.0134 15.2365 15.7094C15.3612 15.7693 15.4235 15.7992 15.5024 15.8222C15.7828 15.904 16.127 15.8453 16.3644 15.6752C16.4313 15.6274 16.4884 15.5702 16.6027 15.4559C16.9523 15.1063 17.1271 14.9315 17.3029 14.8172C17.9658 14.3862 18.8204 14.3862 19.4833 14.8172C19.6591 14.9315 19.8339 15.1063 20.1835 15.4559L20.3783 15.6508C20.9098 16.1822 21.1755 16.448 21.3198 16.7333C21.6069 17.3009 21.6069 17.9712 21.3198 18.5387C21.1755 18.8241 20.9098 19.0898 20.3783 19.6213L20.2207 19.7789C19.6911 20.3085 19.4263 20.5733 19.0662 20.7756C18.6667 21 18.0462 21.1614 17.588 21.16C17.1751 21.1588 16.8928 21.0787 16.3284 20.9185C13.295 20.0575 10.4326 18.433 8.04466 16.045C5.65668 13.6571 4.03221 10.7947 3.17124 7.76131C3.01103 7.19687 2.93092 6.91464 2.9297 6.5017C2.92833 6.04347 3.08969 5.42298 3.31411 5.02348C3.51636 4.66345 3.78117 4.39863 4.3108 3.86901L4.46843 3.71138C4.99987 3.17993 5.2656 2.91421 5.55098 2.76987C6.11854 2.4828 6.7888 2.4828 7.35636 2.76987C7.64174 2.91421 7.90747 3.17993 8.43891 3.71138L8.63378 3.90625C8.98338 4.25585 9.15819 4.43065 9.27247 4.60643C9.70347 5.26932 9.70347 6.1239 9.27247 6.78679C9.15819 6.96257 8.98338 7.13738 8.63378 7.48698C8.51947 7.60129 8.46231 7.65845 8.41447 7.72526C8.24446 7.96269 8.18576 8.30695 8.26748 8.5873C8.29048 8.6662 8.32041 8.72854 8.38028 8.85323Z" 
                            stroke="#2F4B6C" 
                            style={{ stroke: "#2F4B6C", strokeOpacity: 1 }} 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </g>
                </svg>
                <Typography color='#2F4B6C' fontSize={'20px'} fontWeight={700} lineHeight={'28px'}> 
                שירות לקוחות ויצירת קשר
                </Typography>
            </Box>
            <Box sx={{ mt: '10px' }}>
                <Typography color='#2F4B6C' sx={{ fontSize: '15px', fontWeight: 700, lineHeight: '21px' }}>
                שעות פעילות
                </Typography>
            </Box>
            <Box sx={{ mt: '10px' }}>
                {operatingHours.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '160px',
                            mt:'3px'
                        }}
                    >
                        <Typography fontWeight={400} fontSize={'13px'} lineHeight={'19.5px'} color='#546D79'>{item.day}</Typography>
                        <Typography fontWeight={400} fontSize={'13px'} lineHeight={'19.5px'} color='#546D79'>{item.hours}</Typography>
                    </Box>
                ))}
            </Box>
            <Box sx={{ mt: '10px' }}>
                <Typography fontWeight={700} lineHeight={'21px'} fontSize={'15px'} color='#2F4B6C'>
                צרו קשר
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '220px',
                        mt:'5px',
                    }}
                >
                    <Typography fontWeight={400} fontSize={'13px'} lineHeight={'19.5px'} color='#546D79'>טלפון שירות לקוחות</Typography>
                    <Typography
                        component="a"
                        href="tel:073-3743750"
                        sx={{
                            fontWeight: 400,
                            fontSize: '13px',
                            lineHeight: '19.5px',
                            textDecoration: 'underline',
                            color: 'primary.main'
                        }}
                    >
                        073-3743750
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '295px',
                        mt:'5px'
                    }}
                >
                    <Typography fontWeight={400} fontSize={'13px'} lineHeight={'19.5px'} color='#546D79'>מייל שירות לקוחות</Typography>
                    <Typography
                        component="a"
                        href="mailto:View@ShaniShenhav.com"
                        sx={{
                            fontWeight: 400,
                            fontSize: '13px',
                            lineHeight: '19.5px',
                            textDecoration: 'underline',
                            color: 'primary.main'
                        }}
                    >
                        View@ShaniShenhav.com
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '190px',
                        mt:'5px'
                    }}
                >
                    <Typography fontWeight={400} fontSize={'13px'} lineHeight={'19.5px'} color='#546D79'>וואטסאפ שירות לקוחות.</Typography>
                    <Typography
                        component="a"
                        href="https://wa.me/9720733743750"
                        sx={{
                            fontWeight: 400,
                            fontSize: '13px',
                            lineHeight: '19.5px',
                            textDecoration: 'underline',
                            color: 'primary.main'
                        }}
                    >
                        וואטסאפ
                    </Typography>
                </Box>
            </Box>
            <Box 
                mt="auto" 
                display="flex" 
                justifyContent="center" 
                alignItems="center"
                width={'100%'}
            >
                <Box sx={{position:'absolute', bottom:'90px'}}>
                    <Box>
                        <img 
                            src={`${process.env.REACT_APP_MEDIA}/support.png`} 
                            alt="Empty Document" 
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Content;
